'use strict';

define('components/nav/navigation.analytics',[
  './navigation',
  'lib/analytics/context.add',
  'lib/analytics/blocks/index',
  'lib/analytics/click'
], function (
  Navigation,
  anAddContext,
  blocks,
  anClicks
) {
  function __pathToContentSection(path) {
    var startIdx = 2;

    // Include the Expanded region in the content section
    if (path.length >= 2 && path[1].key === 'expanded') {
      startIdx = 1;
    }

    return ['header_nav'].concat(path.slice(startIdx).map(function (l) { return l.title; })).join('/');
  }

  var AnalyticsPlugin = Navigation.Plugin.extend({
    bindEvents: function () {
      var nav = this.getNavigation();
      nav.$el.on('click', '[data-content-section] > a, [data-content-section] > span, [data-content-section] .datalayer-link', this.onDecorateLink.bind(this));
      nav.$el.on('click', '[data-relative-content-section] a, [data-relative-content-section] span, [data-relative-content-section] .datalayer-link', this.onDecorateRelativeLink.bind(this));
      anAddContext(nav.$el, blocks.sectionBlock('header_nav'));
      anClicks(nav.$el);
    },

    onDecorateLink: function (e) {
      var $target = $(e.currentTarget);
      var $parent = $target.closest('[data-content-section]');
      var data = $target.data('anctx') || {};

      if (typeof data !== 'object') {
        data = JSON.parse(data);
      }

      if ($parent.length) {
        data.content_section = $parent.data('content-section');
        anAddContext($target, blocks.sectionBlock(data.content_section));
      }
    },

    onDecorateRelativeLink: function (e) {
      var $target = $(e.currentTarget);
      var contentSection = $target.closest('[data-relative-content-section]').data('relative-content-section');
      var $parent = $target.closest('[data-content-section]');
      var data = $target.data('anctx') || {};

      if (typeof data !== 'object') {
        data = JSON.parse(data);
      }

      if ($parent.length) {
        contentSection = $parent.data('content-section') + '/' + contentSection;
      }

      data.content_section = contentSection;
      anAddContext($target, blocks.sectionBlock(data.content_section));
    },


    onModelLoaded: function (model) {
      var nav = this.getNavigation();

      nav.walk(function (link, path) {
        // Add data to each of the links to match the content_section
        return $.extend({}, link, { 'data-content-section': __pathToContentSection(path) });
      });
    },
  });

  Navigation.registerPlugin(AnalyticsPlugin);
});

